import type { ProductProps } from 'tsconfig/types';

export const buildCartItems = (
  baseProduct: ProductProps | null,
  upsellProduct: ProductProps | null,
  includeUpsell: boolean,
) => {
  const items = [];
  if (baseProduct) {
    items.push({ itemCode: baseProduct.itemCode, quantity: 1 });
  }
  if (upsellProduct && includeUpsell) {
    items.push({ itemCode: upsellProduct.itemCode, quantity: 1 });
  }

  return { cartItems: items };
};
